import type { WidgetRegistration } from '@ayocore/platform/client/widgets';
import { SalesSummaryWidget } from './SalesSummaryWidget';

export { SalesSummaryWidget };

/** Клиентская точка входа; размещение при необходимости переопределяет потребитель. */
export const salesSummaryWidget = {
  code: 'crm.sales-summary',
  title: 'Финансовая сводка',
  Component: SalesSummaryWidget,
  welcome: { key: 'crm-sales-summary', order: 40 },
} satisfies WidgetRegistration;
